<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
      class="table-style"
      stripe
      highlight-hover-row
      show-footer
      show-overflow
      max-height="540"
      border="none"
      :loading="loading"
      :data="receivingListData"
      :auto-resize="true"
      align="center"
      :filter-config="{remote: true}"
      :footer-method="footerMethod"
      @filter-change="filterTypeMethod"
      resizable
    >
      <vxe-table-column type="seq" title="序号" width="60">
        <template slot-scope="{ row, $rowIndex }">
          <span>{{$rowIndex + 1}}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="id" title="操作" width="50">
        <template slot-scope="{ row }">

          <Dropdown
              trigger="click"
              transfer
              v-if="
                isHavePermission('twoSettlement:delete')
              "
          >
            <icon
                type="text"
                custom="iconfont icon-gengduo"
                size="12px"
            ></icon>
            <DropdownMenu slot="list" style="left: 70px">
              <div style="display: flex; flex-direction: column">
                <Button
                    class="button-gengduo"
                    style="color: #ed4014"
                    v-if="isHavePermission('twoSettlement:delete')"
                    @click="delReceiving(row)"
                >删除
                </Button
                >
              </div>
            </DropdownMenu>
          </Dropdown>
        </template>
      </vxe-table-column>
      <vxe-table-column field="paymentsNum" title="结算编号">
        <template slot-scope="{ row }">
          <span
            @click="openReceivingDeail(row)"
            style="cursor:pointer;color: #2d8cf0;"
          >{{ row.paymentsNum }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="paymentType"
          title="结算类型"
          :filters="[ {label: '托运人结算', value: '1'},{label: '承运人结算', value: '2'}]"
          :filter-multiple="false"
      >
        <template slot-scope="{ row }">
          <span>{{ row.paymentType | receiveTypeRule}}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="addTime" title="结算时间">
        <template slot-scope="{ row }">
          <span>{{ row.addTime | timePartRule }}</span>
        </template>
      </vxe-table-column>

      <vxe-table-column field="totalAmount" title="结算金额(元)">
        <template slot-scope="{ row }">
          <span>{{row.totalAmount}}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="note" title="摘要"></vxe-table-column>
    </vxe-table>
    <vxe-modal
      v-model="receivingDeailModal"
      width="1300"
       height="700"
      position="center"
      title="结算信息"
      showFooter
      @closeRec="closeRec"
    >

      <receiving-detail ref="receivingDetail"></receiving-detail>
      <div slot="footer">
        <vxe-button
          type="submit"
          status="primary"
          @click="editReceiving(editRows,1)"
          v-if="isHavePermission('twoSettlement:update')"
          style="width:140px;border-radius: 0px;"
        >编辑</vxe-button>
      </div>
    </vxe-modal>



    <vxe-pager
      background
      size="small"
      :current-page.sync="page.currentPage"
      :page-size.sync="page.pageSize"
      :total="page.totalResult"
      @page-change="handlePageChange"
    ></vxe-pager>
    <edit-receiving
        ref="editReceiving"
        @updateList="updateList"
    ></edit-receiving>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { timeFormatDate } from "@/filters/time";
import { numberToCurrency } from "@/filters/type";
import ReceivingDetail from "@/components/order2.0/Receiving/ReceivingDetail";
import getAuthOrization from "@/mixin/getAuthOrization";

import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import EditReceiving from "@/components/order2.0/Receiving/EditReceiving";
import {hideLoading, showLoading} from "@/utils/util";
export default {
  props: ['id', 'curTab'],
  components: {
    EditReceiving,
    ReceivingDetail
  },
  mixins: [getAuthOrization],

  data() {
    return {
      loading: false,
      editRows: {},
      receivingDeailModal: false,
      receivingListData: [],
      receiveType: null,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      amount: {
        totalRealCounts: 0,
        totalReceAmount: 0,
      },
    };
  },
  filters: {
    receiveTypeRule(p) {
      if (p == 1) {
        return "托运人结算";
      } else if (p == 2) {
        return "承运人结算";
      }
    },
    timePartRule: function (t) {
      if (t) {
        var timeB = new Date(t);
        var y = 1900 + timeB.getYear();
        var m = "0" + (timeB.getMonth() + 1);
        var d = "0" + timeB.getDate();

        return (
            y +
            "-" +
            m.substring(m.length - 2, m.length) +
            "-" +
            d.substring(d.length - 2, d.length)
        );
      } else {
        return "";
      }
    },
  },
  watch: {
    curTab: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val === 3) {
          this.init();
        }
      }
    }
  },
  mounted() {
  },
  methods: {

    init() {
      this.page.currentPage = 1;
      this.getReceivingListData()
    },
    updateList(val) {
      if (val) {
        this.receivingDeailModal = false;
        this.getReceivingListData();
      }
    },
    async getReceivingListData() {
      this.loading = true;
      let res = await $api.twoSettlement.request("list", {
        ordersId: Number(this.id),
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
        isDesc: 1,
        paymentType:this.receiveType
      });
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        var countData = null;
        countData = JSON.parse(res.data.countData)
        if (countData !=null){
          this.amount.totalReceAmount = countData.totalAmount
        }
        else {
          this.amount.totalReceAmount = null
        }
        let receivingListData = res.data.rows;
        receivingListData.map((i) => {
          i.paymentTime = timeFormatDate(i.paymentTime);
          i.amount = numberToCurrency(i.amount);
          // i.receAmount = numberToCurrency(i.receAmount);
        });
        this.receivingListData = receivingListData;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
   confirmEvent(row) {
      this.$XModal
        .confirm("删除后，将解除此订单关联的结算信息", "是否删除此结算信息？")
        .then((type) => {
          if (type === "confirm") {
              this.removeReceive(row);
        }
    })
   },
    openReceivingDeail(row) {
      if (!this.isHavePermission('twoSettlement:detail')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.editRows = row;
        this.receivingDeailModal = true;
        this.$refs.receivingDetail.getReceivingDetail(row);
    },

    async removeReceive(row) {
      var idList = [];
      idList.push(row.id);
      let res = await $api.twoSettlement.request(
          "delete",{
            idList:idList,
            orderId:Number(this.id),
          }
      );
      console.log("xxx")

      if (res.status === 1) {
        this.$XModal.message({ message: `删除成功！` });
        this.getReceivingListData();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    editReceiving(row) {
      this.receivingDeailModal = false;
      this.$refs.editReceiving.editReceiving(row);
    },

    handlePageChange({ currentPage, pageSize }) {
      // 分页
      this.page.currentPage = currentPage;
      this.page.pageSize = pageSize;
      this.getReceivingListData();
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 2) {
            return "单页合计";
          }
          if (["totalAmount"].includes(column.property)) {
            return numberToCurrency(this.$utils.sum(data, column.property));
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 2) {
            return "全部合计";
          }

          if (["totalAmount"].includes(column.property)) {
            return numberToCurrency(this.amount.totalReceAmount);
          }
          return null;
        }),
      ];
    },
    closeRec(val) {
      this.receivingDeailModal = val;

    },
    filterTypeMethod({ column, property, values, datas, filters, $event }) {
      this.page.currentPage = 1;
      if (values.length > 0) {
        this.receiveType = values[0];
      } else {
        this.receiveType = null;
      }
      this.getReceivingListData();
    },
    delReceiving(row) {
      this.$XModal.confirm("您确定要删除吗？").then((type) => {
        if (type === "confirm") {
          this.deleteCommit(row);
        }
      });
    },
    async deleteCommit(row) {
      var idList = [];
      idList.push(row.id);
      showLoading();
      let res = await $api.twoSettlement.request(
          "delete", {
            idList: idList,
          }
      );
      hideLoading();
      if (res.status == 1) {
        this.init();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
        // this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
  },
};
</script>

<style>
</style>